/**
 * Dashboard-specific constants
 * Column keys that support filtering/sorting in the Audit Dashboard
 */

/**
 * Set of filterable column keys for Audit Dashboard
 * Note: totalAmount, deviationAmount, and shipmentNumber are included for sorting UI,
 * but they don't fetch filter values (only show sort buttons)
 */
export const FILTERABLE_COLUMN_KEYS = new Set([
  'aggregateShipmentType',
  'date',
  'totalAmount',
  'invoiceNumber',
  'shipmentNumber',
  'tradeLane',
  'service',
  'status',
  'deviationAmount',
  'incoterm',
  'billedEntity',
  'shipper',
  'consignee',
]);
